module.exports = __webpack_public_path__ + "static/img/1.e68b476.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/1.png
// module id = sibD
// module chunks = 0